import { createTheme } from "@mui/material/styles";

export const hebrewFontFamily = '"Noto Sans Hebrew", sans-serif';

export const appTheme = createTheme({
  typography: {
    fontFamily: hebrewFontFamily,
  },
});
